import * as montrealDeaths from '../data/montreal_deaths.json';
import * as newCasesMontreal from '../data/new_cases_regions.json';
import * as quebecAge from '../data/age.json';
import * as quebecInfectionsByRegion from '../data/infections_by_region.json';
import * as quebecMapPopulationData from '../data/map_population.json';
import * as quebecNewCasesData from '../data/new_cases.json';
import * as quebecTestedData from '../data/tested.json';
import * as quebecTotalCasesData from '../data/total_cases.json';
import * as exponentialData from '../data/exponential.json';
import * as cases from '../data/cases.json';
import * as hospitalization from '../data/hospitilization.json';
import * as montrealMapNeighbourhood from '../data/map_montreal_nhood.json';

import { DataSet } from '../graphs/DataSetInterface';

export const quebecDataSets: DataSet[] = [
  {
    id: 'quebecTotalCasesData',
    title: 'Total cases',
    dataSet: quebecTotalCasesData.default,
    updatedDaily: true,
    sectionTitle: 'Total Cases',
  },
  {
    id: 'cases',
    title: 'Cases',
    dataSet: cases.default,
    updatedDaily: true,
  },
  {
    id: 'hospitalization',
    title: 'Hospitalization',
    dataSet: hospitalization.default,
    updatedDaily: true,
  },
  {
    id: 'quebecMapPopulationData',
    title: 'Total cases per 100k',
    dataSet: quebecMapPopulationData.default,
    updatedDaily: true,
  },
  {
    id: 'montrealMapNeighbourhood',
    title: 'Montreal neighbourhood map',
    dataSet: montrealMapNeighbourhood.default,
    updatedDaily: true,
  },
  {
    id: 'montrealDeaths',
    title: 'Montreal Cases per CIUSS',
    dataSet: montrealDeaths.default,
    updatedDaily: true,
  },
  {
    id: 'exponentialData',
    title: 'Exponential Growth',
    dataSet: exponentialData.default,
    updatedDaily: true,
    sectionTitle: 'Exponential Trends',
  },
  {
    id: 'quebecNewCasesData',
    title: 'New cases',
    dataSet: quebecNewCasesData.default,
    updatedDaily: true,
  },
  {
    id: 'newCasesRegion',
    title: 'New Cases Montreal and Surrounding Regions vs Rest of Quebec',
    dataSet: newCasesMontreal.default,
    updatedDaily: true,
  },
  {
    id: 'quebecTestedData',
    title: 'Tested data',
    dataSet: quebecTestedData.default,
    updatedDaily: true,
  },
  {
    id: 'quebecAge',
    title: 'Deaths by age',
    dataSet: quebecAge.default,
    updatedDaily: true,
  },
  {
    id: 'quebecInfectionsByRegion',
    title: 'Infections over time',
    dataSet: quebecInfectionsByRegion.default,
    updatedDaily: true,
  },
];

export const quebecLinks = quebecDataSets.map(({ id, title }) => {
  return {
    to: `/quebec#${id}`,
    title,
  };
});
